module.exports = {"header":{"search":{"PLACEHOLDER":"Type and hit enter.."}},"offsidebar":{"setting":{"SETTINGS":"Settings"}},"sidebar":{"WELCOME":"Welcome","heading":{"HEADER":"Menu Heading"},"nav":{"SINGLEVIEW":"Single View"}},"dashboard":{"WELCOME":"Welcome"},"topbar":{"notification":{"MORE":"See All Notifications"}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/en.json
// module id = ./src/assets/i18n/en.json
// module chunks = main